import { FC } from 'react';

import { ImagesApp } from '../../../constants/images';
import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import { CouponDetail } from '../../../types/cupom';
import * as Styles from './styles.wrapper-message';

type WrapperMessageProps = {
  idRef: number;
  couponApplied: CouponDetail;
}

const WrapperMessage: FC<WrapperMessageProps> = ({
  idRef,
  couponApplied,
}) => {
  const { translate } = useI18nContext();

  return (
    <Styles.WrapperMessageCoupon id={`wrapper-message-coupon_${idRef}`}>
      <Styles.WrapperIconInfo id={`wrapper-icon-info_${idRef}`}>
        <Styles.IconInfo src={ImagesApp.svg.icInfo} id={`icon-info_${idRef}`} />
      </Styles.WrapperIconInfo>
      <Styles.MessageCoupon id={`message-coupon_${idRef}`}>
        {translate([
          'INFORMATION', `${couponApplied.coupon.limit_ticket > 1
            ? 'PLURAL_COUPON_MESSAGE'
            : 'SINGULAR_COUPON_MESSAGE'}`
        ]).replace('<@quantity>', couponApplied.coupon.limit_ticket.toString())}
      </Styles.MessageCoupon>
    </Styles.WrapperMessageCoupon>
  );
};

export default WrapperMessage;
